import store from "../store";
import { getPositionInScene } from "../Util";
import * as msc from "mascot-vis";
import * as d3 from 'd3';
import { select, toggleAxisHandle, customizeColorPalette, rectSelect } from "../canvasSlice";
import { updateItem } from "../canvasSlice";

var clickHeld = false, rectRegion = false, dragging = false, activeItem = null, downX, downY, itemX = {}, itemY = {};

export const hitTest = (e, scene) => {
    const p = getPositionInScene(e.clientX, e.clientY);
    const cg = store.getState().canvas.selected;
    //if nothing is selected, find target among scene's children
    if (cg.length === 0) {
        return msc.hitTest(scene, p[0], p[1]);
    }
    const sel = scene.getItem(cg[0]);
    if (sel.type === "axis" || sel.type === "legend") {
        return msc.hitTest(scene, p[0], p[1]);
    } else {
        //if selected is leaf, find target among its parent's children
        //this is useful for selecting a sibling of the current selection
        let itm = sel.parent;
        while (itm) {
            let hit = msc.hitTest(itm, p[0], p[1]);
            if (hit) return hit;
            else itm = itm.parent;
        }
        return null;
    }
}

export const mouseDown = (e, scene) => {
    clickHeld = true;
    downX = e.clientX;
    downY = e.clientY;
    let itm = hitTest(e, scene);
    if (itm !== null && itm.type === "legend") {
        if (itm.channel.indexOf("Color") > 0 && itm.fieldType === "string") {
            const p = getPositionInScene(e.clientX, e.clientY);
            const mark = itm.pathHitTest(p[0], p[1]);
            if (mark !== null) {
                //customize categorical color mapping
                const v = mark.dataScope.getFieldValue("category");
                store.dispatch(customizeColorPalette({legend: itm.id, value: v}));
                return;
            }
        }
    }

    store.dispatch(customizeColorPalette({legend: null, value: null}));
    activeItem = itm;
    if (itm === null && e.button === 0) {
        rectRegion = true;
    } else if (itm !== null) {
        //let items = store.getState().canvas.selected.length > 0 ? store.getState().canvas.selected.map(d => scene.getItem(d)) : [itm];
        let items = store.getState().canvas.selected.map(d => scene.getItem(d));
        items.push(itm);
        for (let item of items) {
            itemX[item.id] = item.type === "axis" && (item.channel === "y" || item.channel === "height") ? item.pathX : item.x;
            itemY[item.id] = item.type === "axis" && (item.channel === "x" || item.channel === "width") ? item.pathY : item.y;
        }
        
    }
}

const dragItem = (item, scene, newX, newY, dx, dy) => {
    if (item.type === "axis") {
        store.dispatch(toggleAxisHandle({visible: false}));
        if (item.channel === "x" || item.channel === "width") {
            item.pathY = newY;
        } else if (item.channel === "y" || item.channel === "height") {
            item.pathX = newX;
        }
        store.dispatch(updateItem({id: item.id, type: item.type, properties: {pathPosition: item.pathPosition}}));
    } else {
        scene.translate(item, dx, dy);
        store.dispatch(updateItem({id: item.id, type: item.type, properties: {x: item.x, y: item.y}}));
    }
}

export const mouseMove = (e, scene, renderer) => {

    if (!clickHeld) { //hovering
        const item = hitTest(e, scene);
        if (item && item.type === "axis" && item.encoding) {
            store.dispatch(toggleAxisHandle({axis: item.id, visible: true}));
        } else {
            store.dispatch(toggleAxisHandle({visible: false}));
        }
        return;
    }
 
    //clickHeld
    if (rectRegion) { //rect select
        let pos = getPositionInScene(Math.min(downX, e.clientX), Math.min(downY, e.clientY));
        let left = pos[0], top = pos[1], wd = Math.abs(e.clientX - downX), ht = Math.abs(e.clientY - downY);
        store.dispatch(rectSelect({left: left, top: top, width: wd, height: ht}));
    } else if (activeItem) { //dragging
        let sel = store.getState().canvas.selected, itmInSelection = sel.indexOf(activeItem.id) >= 0;
        if (sel.length === 0 || !itmInSelection) {
            store.dispatch(select([activeItem.id]));
            dragging = true;
            dragItem(activeItem, scene, itemX[activeItem.id] + e.clientX - downX, itemY[activeItem.id] + e.clientY - downY, itemX[activeItem.id] + e.clientX - downX - activeItem.x, itemY[activeItem.id] + e.clientY - downY - activeItem.y);
        } else if (itmInSelection) {
            dragging = true;
            for (let s of store.getState().canvas.selected) {
                const item = scene.getItem(s);
                dragItem(item, scene, itemX[item.id] + e.clientX - downX, itemY[item.id] + e.clientY - downY, itemX[item.id] + e.clientX - downX - item.x, itemY[item.id] + e.clientY - downY - item.y);
            }
        } 
        
        // const s1 = store.getState().canvas.selected[0];
        // if (!s1) return;
    }
}

export const mouseUp = (e, scene, renderer) => {
    let pos = getPositionInScene(Math.min(downX, e.clientX), Math.min(downY, e.clientY));
    let left = pos[0], top = pos[1], wd = Math.abs(e.clientX - downX), ht = Math.abs(e.clientY - downY);
    if (rectRegion && wd > 0 && ht > 0) {
        store.dispatch(rectSelect({left: left, top: top, width: 0, height: 0}));
        let r = {left: left, top: top, width: wd, height: ht, right: left + wd, bottom: top + ht};
        let itms = msc.rectHitTest(scene, r).map(d => d.id);
        for (let m of itms) {
            const itm = scene.getItem(m);
            itemX[itm.id] = itm.type === "axis" && (itm.channel === "y" || itm.channel === "height") ? itm.pathX : itm.x;
            itemY[itm.id] = itm.type === "axis" && (itm.channel === "x" || itm.channel === "width") ? itm.pathY : itm.y;
        }
        store.dispatch(select(itms));
    } else if (!dragging) { //not dragging
        if (activeItem === null) {
            store.dispatch(select([]));
            d3.select("#textElement").style("visibility", "hidden");
            renderer.render(scene);
        } else {
            let sel = store.getState().canvas.selected, newSel;
            let itmInSelection = sel.indexOf(activeItem.id) >= 0;
            if (e.shiftKey && !itmInSelection) {
                newSel = sel.concat(activeItem.id);
            } else if (e.shiftKey && itmInSelection) {
                newSel = sel.filter(d => d !== activeItem.id);
                itemX[activeItem.id] = activeItem.type === "axis" && (activeItem.channel === "y" || activeItem.channel === "height") ? activeItem.pathX : activeItem.x;
                itemY[activeItem.id] = activeItem.type === "axis" && (activeItem.channel === "x" || activeItem.channel === "width") ? activeItem.pathY : activeItem.y;
            } else {
                newSel = [activeItem.id];
            }
            store.dispatch(select(newSel));
        }
    }
    
    // else if (store.getState().canvas.selected.length > 0){
    //     let item = scene.getItem(store.getState().canvas.selected[0]);
    //     if (item === null && !dragging) {
    //         store.dispatch(select([]));
    //     }
    // }
    // let sel = store.getState().canvas.selected;
    // let itmInSelection = sel.indexOf(itm.id) >= 0;
    // if (e.shiftKey) {
    //     store.dispatch(select(sel.concat(itm.id)));
    // } else {
    //     store.dispatch(select([itm.id]));
    // }

    clickHeld = false;
    rectRegion = false;
    dragging = false;
    activeItem = null;
    // itemX = {};
    // itemY = {};
}

export const doubleClick = (e, scene) => {
    const cg = store.getState().canvas.selected;
    if (cg.length> 0) {
        const itm = scene.getItem(cg[0]);
        if (itm && itm.type !== "axis" && itm.type !== "legend" && itm.children && itm.children.length > 0) {
            const p = getPositionInScene(e.clientX, e.clientY);
            let child = msc.hitTest(itm, p[0], p[1]);
            if (child) {
                store.dispatch(select([child.id]));
            }
        }
    }
}